export const tenantSettings = [{ key: 'nymos_api', name: 'neo', theme: 'neoConfig' }];

export const defaultTenantKey = tenantSettings[0];
